import charityVettingApiSlice from 'api/charity-vetting/charityVettingApiSlice';
import { CharityVettingStatus } from 'api/users/types';
import useCharityVettingStatus from 'common/auth/useCharityVettingStatus';
import { CompletionStatus } from 'features/charity-vetting/types/charityVettingTypes';
import { Navigate, Outlet, useLocation } from 'react-router';
import { CHARITY_VETTING_PATH, DONATIONS_PATH } from 'src/core/paths/paths';

// `location.state` is typed `unknown` by react-router; narrow it without a cast.
const isFormJustSubmitted = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && 'justSubmitted' in state && !!state.justSubmitted;

const RequireVettingInProgress = () => {
  const location = useLocation();
  const { isLoading, hasNoCharity, charityVettingStatus } = useCharityVettingStatus();
  const { data: vetting, isLoading: isVettingLoading } =
    charityVettingApiSlice.endpoints.getCharityVetting.useQuery();

  if (isLoading) {
    return null;
  }
  if (hasNoCharity) {
    return <Navigate to={CHARITY_VETTING_PATH} replace />;
  }
  if (charityVettingStatus === CharityVettingStatus.Vetted) {
    return <Navigate to={DONATIONS_PATH} replace />;
  }

  if (isFormJustSubmitted(location.state)) {
    return <Outlet />;
  }

  if (isVettingLoading) {
    return null;
  }
  const isDraft =
    charityVettingStatus === CharityVettingStatus.VettingInProgress &&
    vetting?.completionStatus !== CompletionStatus.SUBMITTED;
  if (isDraft) {
    return <Navigate to={CHARITY_VETTING_PATH} replace />;
  }
  return <Outlet />;
};

export default RequireVettingInProgress;
